import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Site from './Site'
import Content from './Content'
import Footer from './Footer'
import Router from './Router'

const Layout = ({ children }) => (
  <Site>
    <Helmet
      title="Park Park Go"
      meta={[
        { name: 'description', content: 'Park Park Go, find, park, parking, parks, spot, spots, car' },
        { name: 'keywords', content: 'park, parking, car, find, app, business' },
      ]}
      script={[
        { 'src': 'https://use.fontawesome.com/releases/v5.0.3/js/all.js'},
      ]}
      link={[
        {'rel':'stylesheet', 'href': 'https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css'}
      ]}
    />
    <Content>
      <Router>
	     {/* {children()} */}
        <Footer />
      </Router>
    </Content>
  </Site>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/Layout.js